export const DATA = 
[
    {
        id: 1,
        title: ["HAVLU"],
        link: 'havlu',
        colSpan: 1,
        aspectRatio: 1,

        products: [
            {
                title: 'HYDROTOUCH',
                text: 'Yüzyıllardır en kaliteli Ege pamuğunun kaynağı olan tarihi şehir Denizli de üretilmiştir. Eşsiz emiciliği ve olağanüstü yumuşaklığı ile HYDRO TOUCH havlunun cildinizde bıraktığı benzersiz zarafeti, iplik ve dokuma teknolojilerinin profesyonel birleşimi sayesinde hissedeceksiniz.',
                link: 'hydrotouch',
                images: ['0', '1', '2', '3'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },
            {
                title: 'AEROSOFT',
                text: 'AEROSOFT, standartları bir adım daha ileriye taşıyarak sıradanın ötesine geçiyor. Ayrıcalık hissi arayanlar için geliştirilen AEROSOFT kalitesiyle kendinizi harika hissedeceksiniz.',
                link: 'aerosoft',
                images: ['0', '1', '2', '3', '4', '5', '6'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },
            {
                title: 'AIRSMOOTH',
                text: 'DOK-SAN tarafından geliştirilen AIRSMOOTH kalitemiz, standartların üzerine çıkıyor. Ayrıcalık hissi arayanlar için geliştirilen Airsmooth kalitesiyle mükemmelliği hissedeceksiniz.',
                link: 'airsmooth',
                images: ['0', '1', '2','3','4','5','6','7','8','9','10','11','12'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },

            {
                title: 'AQUAFANCY',
                text: 'Yüzyıllardır en kaliteli Ege pamuğunun kaynağı olan Denizli de üretilmiştir. İplik ve dokuma teknolojilerinin profesyonel birleşimi sayesinde desen tasarımına ihtiyaç duymadan sade çizgiler, huzur veren tonlar ve yumuşak bir his sağlayan yüksek havlı havlular üretilebiliyor.',
                link: 'aquafancy',
                images: ['0', '1', '2', '3', '4', '5', '6', '7', '8'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },


            {
                title: 'DREAMYTOUCH',
                text: 'Maksimum su emiciliğiyle, doğal, dolgun ve parlak bir görünümün yanı sıra hayal ettiğiniz yumuşaklığı saf pamuktan deneyimleyeceksiniz.',
                link: 'dreamytouch',
                images: ['0', '1', '2', '3', '4', '5','6','7','8','9','10','11'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },


            {
                title: 'PLUSCOTTON',
                text: 'Süper emici, ultra ince PLUSCOTTON havlular, banyonuzda size konforlu ve çağdaş bir his sunarak sıcaklığı artırır. Yumuşaklığı ve dolgun dokusuyla PLUSCOTTON size mutluluk verir.',
                link: 'pluscotton',
                images: ['0', '1', '2'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },


            {
                title: 'ZEROTWIST',
                text: 'ZEROTWIST kalitesinin sunduğu yumuşaklık ve dolgun görünüm sayesinde tembel sabahlarınız ve gece keyifleriniz vazgeçilmez bir zevke dönüşecek.',
                link: 'zerotwist',
                images: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },


            {
                title: 'SUSTAINABLE QUALITIES',
                text: ['GOTS','GRS','OCS','RCS','NAIA','LENZING FIBERS','KENEVİR KARIŞIMLARI','KETEN KARIŞIMLARI','MODAL KARIŞIMLARI','BAMBU KARIŞIMLARI'],
                link: 'sustainable-qualities',
                images: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },
        ]

    },
    {
        id: 2,
        title: ["BORNOZ"],
        link: 'bornoz',
        colSpan: 1,
        aspectRatio: 1,

        products: [
            {
                title: 'BORNOZ',
                text: 'Yılların tecrübesiyle, hayalinizdeki bornozu birçok kumaş seçeneğimizle ve istediğiniz tasarımda üretebiliyoruz.',
                link: 'bornoz',
                images: ['0', '1', '2', '3', '4', '5', '6', '7', '8'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },

        ]

    },
    {
        id: 3,
        title: ["ÇOCUK"],
        link: 'cocuk',
        colSpan: 1,
        aspectRatio: 1,

        
        products: [
            {
                title: 'ÇOCUK',
                text: '3D tasarımdan düz modellere kadar bebeğinizin banyoda ihtiyaç duyduğu her şeyi bizde bulabilirsiniz. Siz ve bebeğiniz DOKSAN yumuşaklığını hissedeceksiniz.',
                link: 'cocuk',
                images: ['0', '1', '2', '3', '4', '5'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },

        ]

    },
    {
        id: 4,
        title: ["EV"],
        link: 'ev',
        colSpan: 1,
        aspectRatio: 1,

        
        products: [
            {
                title: 'EV GİYİMİ',
                text: '',
                link: 'ev-giyimi',
                images: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59', '60', '61', '62', '63', '64', '65', '66', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '79', '80', '81', '82'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },
                        {
                title: 'PİJAMA',
                text: '',
                link: 'pijama',
                images: ['0', '1', '2', '3', '4', '5','6','7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },
                                    {
                title: 'BATTANİYE',
                text: '',
                link: 'battaniye',
                images: ['0', '1', '2', '3', '4', '5','6','7','8','9','10','11','12','13'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },

            {
                title: 'YASTIK',
                text: '',
                link: 'yastik',
                images: ['0', '1', '2', '3', '4', '5' , '6' , '7'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },
            

        ]

    },
    {
        id: 5,
        title: ["MUTFAK"],
        link: 'mutfak',
        colSpan: 2,
        aspectRatio: 2,

        
        products: [
            {
                title: 'MUTFAK',
                text: 'Geniş aile sofralarının sıcaklığından ve huzurundan ilham alan Kese Home, ilk günkü heyecanla samimi ve sade sofralarınızın vazgeçilmezi olmaya devam ediyor. Ailenin sıcaklığında kurulan eşsiz sofralara, o sofralarda edilen sonsuz sohbetlere ve kurulan güzel bağlara sihirli dokunuşlarımızla eşlik ediyor, unutulmaz anılarınıza imzamızı atıyoruz.',
                link: 'mutfak',
                images: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59', '60', '61', '62', '63', '64', '65', '66', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },

        ]


    },
    {
        id: 6,
        title: ["PLAJA","ÖZEL"],
        link: 'plaja-ozel',
        colSpan: 1,
        aspectRatio: 1,

        
        products: [
            {
                title: 'PLAJ HAVLULARI',
                text: '',
                link: 'plaj-havlulari',
                images: ['0', '1', '2', '3'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },
                        {
                title: 'ŞEZLONG KILIFI',
                text: '',
                link: 'sezlong-kilifi',
                images: ['0', '1', '2', '3'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },
                                    {
                title: 'PLAJ GİYİMİ',
                text: '',
                link: 'plaj-giyimi',
                images: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22','23'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },


        ]


    },
    {
        id: 7,
        title: ["OTEL&SPA"],
        link: 'otel-ve-spa',
        colSpan: 1,
        aspectRatio: 1,


        
        products: [
            {
                title: 'HAVLU',
                text: '',
                link: 'havlu',
                images: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },
            {
                title: 'PEÇETE',
                text: '',
                link: 'pecete',
                images: ['0', '1', '2', '3', '4', '5'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },
  
            {
                title: 'ÖNLÜK',
                text: '',
                link: 'onluk',
                images: ['0', '1', '2', '3', '4', '5'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },
        ]


    },
    {
        id: 8,
        title: ["KUMAŞLAR"],
        link: 'kumaslar',
        colSpan: 1,
        aspectRatio: 1,


        
        products: [


                        {
                title: 'KUMAŞLAR',
                text: 'En üst kalite üretilen ve müşteri memnuniyeti garantili wellsoft kumaş Sağlıklı ve hijyenik yapısı ile sıcak tutma özelliğinden dolayı özel bir kumaştır. Antibakteriyel özelliğe sahip olması nedeniyle astım, alerjik sorunlar ve toz alerjisi gibi durumlar karşısında hem çocuklar hem de yetişkinler için değerlendirebilmektedir.Nefes alma ve sıcak tutma özelliği vardır. Leke tutmayan, kolayca silinen rahat ve yumuşak bir dokuya sahiptir.Ceket, kaban, mont, halı örtüsü, yatak örtüsü, havlu, bornoz, süs eşyaları gibi modeller de rahatlıkla kullanılmaktadır.',
                link: 'kumaslar',
                images: ['0', '1', '2'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },
            {
                title: 'KUZUTÜYÜ KUMAŞ',
                text: 'Kuzutüyü kumaş ilgi ve alaka gören çokta sevilerek her alanda kullanılabilen bir kumaş türüdür.%100 polyesterden yuvarlak örme tekniği ile ürettilmektedir.Kumaşın en belirgin özelliği oldukça yumuşak,sıcak tutabilen ve hafifliği ile ön plana çıkmaktadır.',
                link: 'kuzutuyu-kumas',
                images: ['0', '1', '2', '3'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },



                        {
                title: 'KIRÇILLI KUMAŞ',
                text: 'Kumaşın en belirgin özelliği farklı renk ve desenlerden oluşmasıdır.Birçok renkli ipliklerden örülerek oluşturulan vintage tarzı modellere çok yakışan aynı zamanda modern, havalı şık tasarımlarla zerafet sağlamaktadır.',
                link: 'kircilli-kumas',
                images: ['0', '1'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },



                                    {
                title: 'ULTRASOFT',
                text: 'Çözgülü örme tekniği ile üretimi sağlanan polyester içeren  ultrasoft kumaş parlak ve pürüzsüz bir dokuya sahiptir.Yumaşak yapısı ve dayanıklılığı ile ön plandadır.',
                link: 'ultrasoft',
                images: ['0', '1', '2', '3', '4'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },






                                                {
                title: 'LUXE TOUCH',
                text: 'Luxe touch kumaş, genellikle sentetik liflerden üretilen, oldukça yumuşak ve dolgun bir yüzeye sahip bir kumaş türüdür. Bu kumaş, özellikle soğuk havalarda sıcak tutması ve yumuşak dokusuyla öne çıkar.Luxe toch benzersiz yapısı, içindeki liflerin dik bir şekilde dokunmasından gelir ve bu özellik, kumaşa karakteristik bir kabarıklık verir.Yumuşaklığın ve Konforun Simgesidir.',
                link: 'luxe-touch',
                images: ['0', '1', '2', '3', '4', '5'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },





                                                            {
                title: 'CHİNCİLA',
                text: 'Estetik açıdan uzun ve kısa tüylü parlak ve hafifliği  ile ön plandadır. Yumuşak ve tüylü bir dokuyla karakterize edilen bir tür kumaştır.Giyimde ev tekstilinde ve pelüş oyuncak üretiminde bu kumaş tercih edilmektedir.',
                link: 'chincila',
                images: ['0', '1', '2'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },



            
                                                            {
                title: 'POLARMAX',
                text: 'Polar kumaşın sıcaklığını ve hafifliğini daha tok ve güçlü bir yapıyla buluşturan yeni nesil bir kumaştır. Dayanıklılığı ve şık görünümü sayesinde dış giyimde üstün performans sunar. Kış aylarında soğuk havaya karşı koruma sağlayan bu kumaş, hem şehir yaşamı hem de zorlu hava koşulları için mükemmel bir seçimdir.',
                link: 'polarmax',
                images: ['0', '1'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },




                                                                                                                                                                                                                                                                                    {
                title: 'POLAR',
                text: 'Polar kumaş kadifemsi dokusu ve yumaşaklık hissi yüksek bir kumaş çeşididir.Sıcak tutma özelliği ile kışın yoğun olarak kullanılır.Antibakteriyel ve leke tutmayan bir özelliğe sahiptir.',
                link: 'polar',
                images: ['0', '1'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },





                                                                                    {
                title: 'DUALSOFT',
                text: 'Pamuk yüzeyin doğal pürüzsüzlüğünü ve polyester kısmın hafif dokulu yapısını bir araya getirerek çift taraflı bir konfor sunuyor. Arka yüzündeki pamuk, yumuşak ve cilde dost bir dokunuş sağlarken ön yüzündeki polyester, hafif topaklı dokusuyla hem dayanıklılık hem de modern bir estetik katıyor.Bu kumaş, hem günlük yaşamın şıklığına hem de sportif ve rahat bir kullanımın gerekliliklerine mükemmel uyum sağlar. İster evde dinlenirken ister dışarıda aktif bir gün geçirirken, DualSoft her an size eşlik eder.',
                link: 'dualsoft',
                images: ['0', '1', '2'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },




                                                                                                                                                                                                                {
                title: 'MELANJ POLAR',
                text: 'Değişik renkdeki elyafların farklı oranlarda karıştırılması ile hazırlanan çok renkli kumaş türüdür.İplik yapısı sayesinde melanj görünümü verir.Tüylü ve yumaşak görüntüye sahiptir.',
                link: 'melanj-polar',
                images: ['0', '1'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },



                                                                                                            {
                title: 'COTTONGUARD',
                text: 'Yüksek kaliteli pamuk ipliklerinden üretilen bir tür örme kumaşı ifade eder. genellikle t-shirt, iç giyim ve bebek kıyafetleri gibi cilde direkt temas eden giysilerde tercih edilir.Dokuları nedeniyle ciltte yumuşak bir his bırakır ve genellikle hipoalerjeniktir.',
                link: 'cottonguard',
                images: ['0', '1'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },




                                                                                                                        {
                title: 'MAYER',
                text: 'Çözgülü örme tekniği ile pamuk mikrocotton bambu ve mikrofiber iplikleri birleştirilerek ev giyimi bornoz sabahlık çocuk giyimi tek ve çift taraflı havlu kumaşlar üretilmektedir.Heryüzü farklı kompozisyon renk ve desen olabilen çözgülü örme havlu kumaşlar yumuşak su emiciliği yüksek çabuk kuruyan alerji yapmayan yırtılmaya karşı dayanıklı ev tekstilinde tasarım ve uygulama için geniş bir çeşide sahiptir.',
                link: 'mayer',
                images: ['0', '1', '2', '3'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },



            
                                                                                                                        {
                title: 'MAYER KADİFE',
                text: 'Kadifemsi yüzeyi ile ipeksi ve yumaşak yapıya sahiptir.Kadife dokusunun verdiği parlaklık sayesinde ışığı yansıtır ve buda kumaşa derinlik kazandırır.',
                link: 'mayer-kadife',
                images: ['0', '1'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },



                        
                                                                                                                        {
                title: 'DOUTOUCH',
                text: 'Çözgülü örme tekniği ile pamuk ve polyester ipliklerin birleşimiyle üretilmektedir.Çift yönlü kullanılabilir.Yumaşak ve kadifemsi yapısı sayesinde ev tekstili ve giyimde büyük talep görmektedir.',
                link: 'doutouch',
                images: ['0'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },



                                                                                                                                                                                                                                                                                        {
                title: 'MİCROFİBER',
                text: 'Microfiber kumaşlar genellikle polyester gibi sentetik liflerden üretilen son derece ince liflere sahip bir kumaş türüdür.Hafif ve yumaşak dokusu ile bilinir.Dayanıklılığı ve su emiciliği ön plandadır.',
                link: 'microfiber',
                images: ['0', '1'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },




            
                                                                                                                                                                                                                                                                                                    {
                title: 'VİSKON KADİFE',
                text: 'Viskon kumaş, genellikle doğal selülozdan elde edilen ve çeşitli işlemlerle üretilen bir tür yapay elyaftır. Viskon, pamuk veya bambu gibi bitkisel kaynaklardan elde edilen selülozun kimyasal işlemlerle çözülüp yeniden şekillendirilmesiyle üretilir. Viskon, doğallığı ve rahatlığı nedeniyle tekstil endüstrisinde sıkça tercih edilir.',
                link: 'viskon-kadife',
                images: ['0', '1'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },








                                                                                                                                                            {
                title: 'ELMAS KADİFE',
                text: 'İhtişamlı duruşu ve ipeksi dokunuşuyla göz kamaştıran bir kumaş türü olan elmas kadife aynı zamanda sahip olduğu renkleri çok daha kaliteli bir biçimde yansıtmasıylada bilinir.',
                link: 'elmas-kadife',
                images: ['0', '1', '2', '3'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },


                                                                                                                                                                        {
                title: 'FİTİLLİ KADİFE',
                text: 'Kumaşı fitilleriyle güçlendiren şık tasarımlarla göz alıcı görünümler yaratan son dönemin dikkat çeken kumaşlarından biridir.',
                link: 'fitilli-kadife',
                images: ['0', '1'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },




                                                                                                                                                                                    {
                title: 'MÜSLİN',
                text: 'Müslin kumaş, ince, hafif ve yumuşak bir dokuma kumaş türüdür. Genellikle pamuk veya pamuk karışımlı liflerden üretilir. Bu nedenle yazlık giysilerde ve bebek ürünlerinde sıkça tercih edilir.',
                link: 'muslin',
                images: ['0', '1', '2', '3', '4', '5'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },



                                                                                                                                                                                                                                                                                                                                                                                                            {
                title: 'PİKE',
                text: 'Nefes alma özelliği ile birlikde yumaşak ve dayanıklı bir yapıya sahip pike kumaşımız evinizin konforunu ve şıklığını arttırır.',
                link: 'pike',
                images: ['0', '1', '2'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },




                                                                                                                                                                                                            {
                title: 'İKİ İPLİK',
                text: 'Çift yüzlü yapısı ve yumuşaklığı pamuk/ polyesterin birleşimini esnek bir şekilde yansıtır.Hafif polar dokusu ile konforu ön planda tutar.',
                link: 'iki-iplik',
                images: ['0', '1'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']

            },
            {
                title: 'WELSOFT',
                text: 'En üst kalite üretilen ve müşteri memnuniyeti garantili welsoft kumaş. Sağlıklı ve hijyenik yapısı ile sıcak tutma özelliğinden dolayı özel bir kumaştır.',
                link: 'welsoft',
                images: ['0', '1', '2', '3'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']
            },
            {
                title: 'NİKY KADİFE',
                text: 'Kadifemsi yüzeyi ile ipeksi ve yumuşak yapıya sahiptir. Kadife dokusunun verdiği parlaklık sayesinde ışığı yansıtır ve bu da kumaşa derinlik kazandırır.',
                link: 'niky-kadife',
                images: ['0', '1', '2', '3', '4', '5', '6', '7'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']
            },
            {
                title: 'KATYONİK',
                text: 'Katyoni kumaş, özel işlem görmüş yumuşak ve emici bir yapıya sahiptir.',
                link: 'katyonik',
                images: ['0'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']
            },
            {
                title: 'İKİ İPLİK ELMAS',
                text: 'Çift yüzlü yapısı ve yumuşaklığı pamuk/polyesterin birleşimini esnek bir şekilde yansıtır. Elmas kadife dokusu ile konforu ön planda tutar.',
                link: 'iki-iplik-elmas',
                images: ['0', '1'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']
            },
            {
                title: 'LUNORA',
                text: 'Lunora kumaş, yumuşak ve lüks bir dokuya sahip özel bir kumaş türüdür.',
                link: 'lunora',
                images: ['0', '1'],
                detail: ['%75 Polyester', '%25 Ketendir.', 'Peçete: 40x40 cm']
            },



        ]


    }
];
